<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 fxHide.sm fxHide.md fxHide.lg fxHide.xl>
                {{ t("application.tab.disclosure") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/disclosure-icon.svg"
                        alt="disclosure-icon"
                    />
                    <h2 [innerHTML]="t('application.disclosure.header')"></h2>
                    <p
                        class="title"
                        *ngIf="client?.disclosureHtml1"
                        [innerHTML]="client?.disclosureHtml1"
                    ></p>
                    <p
                        class="title"
                        *ngIf="client?.disclosureHtml2"
                        [innerHTML]="client?.disclosureHtml2"
                    ></p>
                    <app-disclosure-form
                        [fields]="fields$ | async"
                        [value]="formValue$ | async"
                        [submitting]="submitting"
                        (submitted)="onSubmitted($event)"
                    ></app-disclosure-form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined">
                    <h2>Empty area (intended)</h2>
                </mat-card>
            </div>
        </div>
    </div>
</ng-container>
